<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <!-- Data Peserta -->
  <CCardBody>
    <CRow>
      <div class="col-sm-12 col-xl-6">
        <div class="form-group">
          <label for="" class="font-weight-bold">Pilih Periode</label>
          <multiselect
            class="multi-select"
            label="label"
            placeholder="Pilih Periode"
            :show-labels="false"
            required
            v-model="periode"
            @select="changePeriode"
            :options="dataTahun"
          ></multiselect>
        </div>
      </div>
      <div class="col-sm-12 col-xl-6">
        <div class="form-group">
          <label for="" class="font-weight-bold">Pilih Sertifikasi</label>
          <multiselect
            class="multi-select"
            label="nama_sertifikasi"
            placeholder="Pilih Sertifikasi"
            :show-labels="false"
            required
            v-model="sertifikasi"
            @select="changeSertifikasi"
            :options="dataSertifikasi"
          ></multiselect>
        </div>
      </div>

      <div class="col-sm-12 col-xl-12">
        <!-- <div style="float: left">
          <button class="btn btn-info" @click="download">
            Download Data Pembayaran
          </button>
        </div> -->
        <div style="float: right">
          <button class="btn btn-info mr-2" @click="resetFilter">
            Reset Filter
          </button>
          <button class="btn btn-success" @click="changePelatihan">
            Terapkan Filter
          </button>
        </div>
      </div>
    </CRow>
  </CCardBody>
  <!-- End Data Peserta -->
</template>

<script>
import PeriodeService from "@/services/datamaster/periode.service";
import PaymentService from "@/services/finance/payment.service";
import MasterSertifikasiService from "@/services/sertifikasi/master-sertifikasi.service";
import { AlertUtils } from "@/mixins/AlertUtils";
import { Pagination } from "@/mixins/Pagination";
import { KategoriAnggota } from "@/mixins/master/KategoriAnggota";
import { exportUtils } from '@/mixins/exportUtils';

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false,
  },
  {
    key: "no_anggota",
    label: "No Anggota",
    sorter: true,
    filter: false,
  },
  {
    key: "nama_lengkap",
    label: "Nama",
    sorter: true,
    filter: false,
  },
  {
    key: "tanggal_daftar",
    label: "Tanggal Daftar",
    sorter: true,
    filter: false,
  },
  {
    key: "status_pembayaran",
    label: "Status Pembayaran",
    sorter: true,
    filter: false,
  },
  {
    key: "aksi",
    _style: "width: 10% text-align: center",
    sorter: false,
    filter: false,
  },
];

export default {
  mixins: [AlertUtils, Pagination, KategoriAnggota, AlertUtils],
  filters: {
    date(value) {
      if (!value) return "";
      let options = { year: "numeric", month: "long", day: "numeric" };
      return Intl.DateTimeFormat("id-ID", options).format(value);
    },
  },
  data() {
    return {
      formFilter: {
        periode: "",
        value: "",
        id_sertifikasi: "",
        status_pembayaran: "",
        startDate: "",
        endDate: "",
      },
      formData: [
        {
          idWorkshopPelatihan: "",
          id_workshop_pelatihan: "",
        },
      ],
      sertifikasi: "",
      periode: "",
      kategori_anggota: "",
      dataSertifikasi: [],
      items: [],
      detailPeserta: {
        id_keanggotaan: "",
        id_user: "",
        id_pelatihan_peserta: "",
        nama_pelatihan: "",
        id_workshop_pelatihan: "",
        no_anggota: "",
        nama_lengkap: "",
        tanggal_daftar: "",
        status_pembayaran: "",
        id_invoice: "",
        created_at: "",
        pelatihan_created_at: "",
        no_lapor_pelatihan: "",
        skp: "",
      },
      dataPelatihan: [],
      dataTahun: [],
      fields,
      details: [],
      status: false,
      myModal: false,
      modalDetail: false,
      modalDetailPeserta: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
    };
  },

  mounted() {    
    this.getPeriode();    
  },

  methods: {
    changeSertifikasi(value) {
      this.formFilter.id_sertifikasi = value.id_sertifikasi;      
    },

    filterData() {
      this.$parent.filterData(this.formFilter);
    },

    resetFilter() {
      this.periode = "";
      this.sertifikasi = "";
      this.formFilter.tahun_daftar = new Date().getFullYear();
      $("#filterStatusPembayaran").val("");
    },    

    getPeriode() {
      PeriodeService.getPeriodeSelect()
        .then((response) => {
          this.dataTahun = response.data.data;
          var periode = this.dataTahun.find((el) => el.status === "1");
          
          
          this.periode = {
            label: periode.label,
            value: periode.value
            };
          this.formFilter.periode = periode.value;
          this.getSertifikasi()
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getSertifikasi() {
      MasterSertifikasiService.getSertifikasi(0, 100000, "default")
        .then((response) => {
          // comment console console.log(response.data.data.content);
          this.dataSertifikasi = response.data.data.content;
          this.sertifikasi = {
            nama_sertifikasi : this.dataSertifikasi[0].nama_sertifikasi
          }         
          this.formFilter.id_sertifikasi = this.dataSertifikasi[0].id_sertifikasi
          var value = {
            id : this.formFilter.id_sertifikasi,
            periode : this.formFilter.periode,
          }
          this.$parent.changePelatihan(value);
          this.exportData(value);
        })
        .catch((error) => {
          onsole.log(error);
        });
    },

    // getTahun() {
    //   for (let index = 0; index < 30; index++) {
    //     this.dataTahun.push({
    //       labelPeriode: 2020 + index,
    //       value: 2020 + index,
    //     });
    //   }
    // },

    changePelatihan() {
      var value = {
        id : this.formFilter.id_sertifikasi,
        periode : this.formFilter.periode,
      }
      this.$parent.changePelatihan(value);
    },

    changePeriode(value) {
      this.formFilter.periode = value.value
    },

    download(value) {
      var value = {
        id : this.formFilter.id_sertifikasi,
        periode : this.formFilter.periode,
      }
      this.$parent.download(value);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
